import React from "react";
import { Box, Button, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import SEO from "../../hooks/SEO";
import PageBanner from "../../components/PageBanner";
import NotFound from "../../components/NotFound";
import { posts, siteMeta } from "../../data/mockData";

const PostDetails = () => {
  const { slug, id } = useParams();
  const post = posts.find((entry) => entry.slug === slug || entry.id === id);

  if (!post) {
    return (
      <>
        <SEO
          title="Article Not Found | Refwa"
          description="The requested Refwa article could not be found."
          name={siteMeta.name}
          type="website"
        />
        <NotFound />
      </>
    );
  }

  return (
    <>
      <SEO
        title={`${post.title} | Refwa`}
        description={post.summary}
        name={siteMeta.name}
        type="article"
      />
      <PageBanner
        title={post.title}
        description={post.summary}
        image={post.cover}
        breadcrumbs={[
          { label: "Articles", to: "/articles" },
          { label: post.title },
        ]}
      />
      <Box className="site-section">
        <Container maxWidth="md">
          <Grid container spacing={{ xs: 3, md: 4 }} sx={{ width: "100%", m: 0 }}>
            <Grid item xs={12} lg={8}>
              <Paper
                sx={{
                  p: { xs: 3, md: 4.5, lg: 5 },
                  borderRadius: "var(--radius-panel)",
                  border: "1px solid var(--color-border)",
                  boxShadow: "var(--shadow-card)",
                }}
              >
                <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 800 }}>
                  {post.category}
                </Typography>
                <Typography variant="h3" sx={{ mt: 1.5, maxWidth: 760 }}>
                  {post.title}
                </Typography>
                {post.body.map((paragraph) => (
                  <Typography
                    key={paragraph}
                    variant="body1"
                    color="text.secondary"
                    sx={{ mt: 2.3, maxWidth: 780, lineHeight: 1.92 }}
                  >
                    {paragraph}
                  </Typography>
                ))}
              </Paper>
            </Grid>
            <Grid item xs={12} lg={4}>
              <Paper
                sx={{
                  p: { xs: 2.8, md: 3.2 },
                  borderRadius: "var(--radius-card)",
                  border: "1px solid var(--color-border)",
                  boxShadow: "var(--shadow-card)",
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
                }}
              >
                <Box className="eyebrow">Article context</Box>
                <Typography variant="h5" sx={{ mt: 1.5 }}>
                  Sector Commentary
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1.35 }}>
                  This article forms part of Refwa's commentary on mining,
                  trade, petroleum services, and related project support.
                </Typography>
                <Stack spacing={1.5} sx={{ mt: 2.6 }}>
                  <Button component={RouterLink} to="/articles" variant="contained" size="large" fullWidth>
                    View Articles
                  </Button>
                  <Button component={RouterLink} to="/services" variant="outlined" size="large" fullWidth>
                    Explore Services
                  </Button>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default PostDetails;
